import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

function uint8ArrayToString (u8a) {
  return JSON.stringify(Array.from(u8a))
}

function stringToUint8Array (str) {
  return new Uint8Array(JSON.parse(str))
}

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

import { toHash } from "../assets/js/util";

const store = new Vuex.Store({
  state: {
    isMentenance: false,
    isConnecting: false,
    isGettedAgreedTermsInfo: false, //利用規約の同意状況情報を取得しているか
    targetPuriId: 0,
    sequenceNumber: 0,
    token: '',
    hashedPassword: '',
    passwordLength: 0,
    lineAccessToken: '',
    twitterAccessToken: '',
    tutorial: {},
    membershipGrade: 0,
    registrationType: -1,
    mailAddress: '',
    md5playerId: '',
    paidMemberRegistrationTappedPagePath: '/',
  },
  
  getters: {
    incrementedSequenceNumber(state) {
      return state.sequenceNumber++
    },
    isLogin(state) {
      return state.token !== ''
    },
    token(state) {
      if (state.token === '') {
        return new Uint8Array(16)
      }
      return stringToUint8Array(state.token)
    },
    hashedPassword(state) {
      return state.hashedPassword
    },
    securePassword(state) {
      return '*'.repeat(state.passwordLength)
    },
    lineAccessToken(state) {
      return state.lineAccessToken
    },
    twitterAccessToken(state) {
      return state.twitterAccessToken
    },
    tutorialByPath: (state) => (path) => {
      return state.tutorial[path] || false
    },
    isFreeMembership(state) {
      return state.membershipGrade === pb.LoginResp.MembershipGrade.FREE
    },
    canRemovePaidMembership(state) {
      return state.registrationType === pb.LoginResp.RegistrationType.WEB_REGIST
    },
    mailAddress(state) {
      return state.mailAddress
    },
    md5playeerId(state) {
      return state.md5playerId
    },
    paidMemberRegistrationTappedPagePath(state) {
      return state.paidMemberRegistrationTappedPagePath
    },
    accountCount(state) {
      const accounts = [
        state.hashedPassword,
        state.lineAccessToken,
        state.twitterAccessToken
      ]
      return accounts.filter(a => a.length > 0).length
    }
  },
  
  mutations: {
    SET_SEQUENCE_NUMBER(state, number) {
      state.sequenceNumber = number
    },
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_PASSWORD_LENGTH(state, passwordLength) {
      state.passwordLength = passwordLength
    },
    SET_HASHED_PASSWORD(state, hashedPassword) {
      state.hashedPassword = hashedPassword
    },
    SET_LINE_ACCESS_TOKEN(state, accessToken) {
      state.lineAccessToken = accessToken
    },
    SET_TWITTER_ACCESS_TOKEN(state, accessToken) {
      state.twitterAccessToken = accessToken
    },
    SET_TUTORIAL(state, tutorial) {
      state.tutorial = JSON.parse(tutorial)
    },
    SET_TUTORIAL_FLAG(state, path) {
      state.tutorial[path] = true
    },
    SET_MEMBERSHIP_GRADE(state, grade) {
      state.membershipGrade = grade
    },
    SET_REGISTRATION_TYPE(state, type) {
      state.registrationType = type
    },
    SET_MAIL_ADDRESS(state, addr) {
      state.mailAddress = addr
    },
    SET_MD5_PLAYERID(state, playerId) {
      state.md5playerId = playerId
    },
    SET_PAID_MEMBER_REGISTRATION_TAPPED_PAGE_PATH(state, path) {
      state.paidMemberRegistrationTappedPagePath = path
    }
},
  
  actions: {
    generateSequenceNumber ({ commit }) {
      commit('SET_SEQUENCE_NUMBER', Math.floor(Math.random() * 1000000))
    },
    login({ commit }, { token, membershipGrade, mailAddress, playerId, registrationType }) {
      const s = uint8ArrayToString(token)
      commit('SET_TOKEN', s)
      commit('SET_MEMBERSHIP_GRADE', membershipGrade)
      commit('SET_MAIL_ADDRESS', mailAddress)
      commit('SET_MD5_PLAYERID', toHash('md5', playerId))
      commit('SET_REGISTRATION_TYPE', registrationType)
    },
    logout({ commit }) {
      commit('SET_TOKEN', '')
      commit('SET_HASHED_PASSWORD', '')
      commit('SET_PASSWORD_LENGTH', 0)
      commit('SET_TUTORIAL', JSON.stringify({}))
      commit('SET_MEMBERSHIP_GRADE', -1)
      commit('SET_MAIL_ADDRESS', '')
      commit('SET_MD5_PLAYERID', '')
      commit('SET_REGISTRATION_TYPE', -1)
    },
    savePassword({ commit }, password) {
      commit('SET_PASSWORD_LENGTH', password.length)
      commit('SET_HASHED_PASSWORD', toHash('sha512', password))
    },
    saveLineAccessToken({ commit }, accessToken) {
      commit('SET_LINE_ACCESS_TOKEN', accessToken)
    },
    removeLineAccessToken({ commit }) {
      commit('SET_LINE_ACCESS_TOKEN', '')
    },
    saveTwitterAccessToken({ commit }, accessToken) {
      commit('SET_TWITTER_ACCESS_TOKEN', accessToken)
    },
    removeTwitterAccessToken({ commit }) {
      commit('SET_TWITTER_ACCESS_TOKEN', '')
    },
    saveTutorialFlag({ commit }, path) {
      commit('SET_TUTORIAL_FLAG', path)
    },
    saveTutorial({ commit }, obj) {
      commit('SET_TUTORIAL', JSON.stringify(obj))
    },
    saveMembershipGrade({ commit }, grade) {
      commit('SET_MEMBERSHIP_GRADE', grade)
    },
    saveRegistrationType({ commit }, type) {
      commit('SET_REGISTRATION_TYPE', type)
    },
    saveMailAddress({ commit }, addr) {
      commit('SET_MAIL_ADDRESS', addr)
    },
    savePaidMemberRegistrationTappedPagePath({ commit }, path) {
      commit('SET_PAID_MEMBER_REGISTRATION_TAPPED_PAGE_PATH', path)
    },
  },
  
  plugins: [createPersistedState()],
})

export default store
